exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".getVerifyModalContent__phoneLink___1xqN5 {\n  color: #3f3f3f;\n  cursor: auto; }\n  .getVerifyModalContent__phoneLink___1xqN5:hover {\n    color: #3f3f3f; }\n  @media (max-width: 576px) {\n    .getVerifyModalContent__phoneLink___1xqN5 {\n      text-decoration: underline;\n      cursor: pointer; }\n      .getVerifyModalContent__phoneLink___1xqN5:hover {\n        color: #f94144; } }\n", ""]);

// exports
exports.locals = {
	"phoneLink": "getVerifyModalContent__phoneLink___1xqN5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/services/getVerifyModalContent.scss
// module id = 1733
// module chunks = 6